import { render, staticRenderFns } from "./GridPagingMini.vue?vue&type=template&id=652ec406"
import script from "./GridPagingMini.vue?vue&type=script&lang=js"
export * from "./GridPagingMini.vue?vue&type=script&lang=js"
import style0 from "./GridPagingMini.vue?vue&type=style&index=0&id=652ec406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports